import Table from "react-bootstrap/Table";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Pagination from "react-bootstrap/Pagination";
import ListGroup from "react-bootstrap/ListGroup";

export default function TransferTable({
  transfers,
  meta,
  setPage,
  currentKey,
  cancelTransfer,
}) {
  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const paginationBasic = () => {
    let active = meta?.page;
    let items = [];

    for (let number = 1; number <= meta?.pageCount; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === active}
          onClick={() => setPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    return (
      <div>
        <Pagination size="md">{items}</Pagination>
      </div>
    );
  };

  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            {currentKey === "sent" && <th>Transferee Email</th>}
            {currentKey === "received" && <th>From</th>}
            <th>Event</th>
            <th>Tickets</th>
            <th>Transferred On</th>
            <th>Status</th>
            {currentKey === "sent" && <th></th>}
          </tr>
        </thead>
        <tbody>
          {transfers &&
            transfers.map((transfer, index) => (
              <tr key={index}>
                {currentKey === "sent" && (
                  <td>{transfer?.attributes?.emailAddressToUser}</td>
                )}
                {currentKey === "received" && (
                  <td>{transfer?.attributes?.fromUserEmail}</td>
                )}
                <td>
                  {transfer?.attributes?.event?.data?.attributes?.name} -{" "}
                  {formatDate(
                    transfer?.attributes?.event?.data?.attributes?.start
                  )}
                </td>
                <td>{ticketsList(transfer?.attributes?.tickets?.data)}</td>
                <td>{formatDate(transfer?.attributes?.createdAt)}</td>
                <td>{transfer?.attributes?.status}</td>
                {currentKey === "sent" && (
                  <td>
                    <DropdownButton
                      id="dropdown-basic-button"
                      title="Actions"
                      size="sm"
                      disabled={
                        transfer?.attributes?.status === "claimed" ||
                        transfer?.attributes?.status === "canceled"
                          ? true
                          : false
                      }
                    >
                      <Dropdown.Item
                        href="#/action-3"
                        onClick={() => cancelTransfer(transfer)}
                      >
                        Cancel
                      </Dropdown.Item>
                    </DropdownButton>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </Table>
      {paginationBasic()}
    </>
  );
}

const ticketsList = (tickets) => {
  let sorted = tickets.sort((a, b) => {
    if (a.attributes.sectionNumber !== b.attributes.sectionNumber)
      return a.attributes.sectionNumber.localeCompare(
        b.attributes.sectionNumber
      );
    if (a.attributes.rowNumber !== b.attributes.rowNumber)
      return a.attributes.rowNumber - b.attributes.rowNumber;
    return a.attributes.seatNumber - b.attributes.seatNumber;
  });

  return (
    <>
      <ListGroup variant="flush">
        {sorted &&
          sorted.map((s, index) => (
            <ListGroup.Item
              as="li"
              key={index}
              style={{ backgroundColor: "transparent" }}
            >
              Section {s.attributes.sectionNumber} Row {s.attributes.rowNumber}{" "}
              Seat {s.attributes.seatNumber}
            </ListGroup.Item>
          ))}
      </ListGroup>
    </>
  );
};
